import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinimize = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.16667 10C4.16667 9.53976 4.53976 9.16667 5 9.16667H15C15.4602 9.16667 15.8333 9.53976 15.8333 10C15.8333 10.4602 15.4602 10.8333 15 10.8333H5C4.53976 10.8333 4.16667 10.4602 4.16667 10Z",
		fill: "currentColor"
	})
});
export default SvgMinimize;
